import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist';

const { persistAtom } = recoilPersist();
export const previewCaptureState = atom<boolean>({
  key: 'previewCaptureState',
  default: true,
  effects_UNSTABLE: [persistAtom],
});
